/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "name": "Reshape Tool Tweaks",
  "description": "Tweaks the reshape tool in the costume editor. Square handles, customized size, and more!",
  "tags": [
    "new",
    "theme"
  ],
  "credits": [
    {
      "name": "SharkPool"
    }
  ],
  "enabledByDefault": false,
  "dynamicDisable": true,
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "settings": [
    {
      "dynamic": true,
      "name": "Handle size (3-50px)",
      "id": "handleSize",
      "type": "integer",
      "min": 3,
      "default": 8,
      "max": 25
    },
    {
      "id": "handleShape",
      "name": "Handle shape",
      "type": "select",
      "dynamic": true,
      "default": "square",
      "potentialValues": [
        { "id": "square", "name": "square" },
        { "id": "circle", "name": "circle" },
      ]
    },
  ]
};
export default manifest;
